import type { SubscriptionBilling, SubscriptionPlan } from "@/schemas/subscription-billing.schema";
import { api } from "@/services/api";

export const subscriptionApi = {
  async getPlans() {
    const { data } = await api.get<SubscriptionPlan[]>("/billing/subscriptions/plans");
    return data;
  },

  async getCurrentBilling() {
    const { data } = await api.get<SubscriptionBilling>("/billing/subscriptions/current");
    return data;
  },

  async createSubscription(planName: string) {
    const { data } = await api.post<SubscriptionBilling>("/billing/subscriptions", {
      plan_name: planName,
    });
    return data;
  },

  async changeSubscription(newPlanName: string) {
    const { data } = await api.post<{ success: boolean }>("/billing/subscriptions/change", {
      new_plan_name: newPlanName,
    });
    return data;
  },

  async cancelSubscription() {
    const { data } = await api.delete<{ success: boolean }>("/billing/subscriptions/current");
    return data;
  },

  async reactivateSubscription() {
    const { data } = await api.post<{ success: boolean }>("/billing/subscriptions/reactivate");
    return data;
  },

  async changePaymentMethod(paymentMethodId: string) {
    const { data } = await api.patch<{ success: boolean }>("/billing/subscriptions/payment-method", {
      payment_method_id: paymentMethodId,
    });
    return data;
  },
};
